import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { DetailContainer } from '../easyclaim.app.components/index';

export interface IBankAccountDetailsProps {
	bankAccountOwnerName?: string | null;
	bankAccountNumber?: string | null;
}

export const BankAccountDetails = (props: IBankAccountDetailsProps) => {
	if (!props.bankAccountOwnerName && !props.bankAccountNumber) {
		return null;
	}

	return (
		<>
			<h2 className="approval-account-title">
				<FormattedMessage id="payout.headline.first" />
			</h2>
			<Paragraph>
				<FormattedMessage id="approval.description" />
			</Paragraph>
			<DetailContainer>
				<FormattedMessage id="completePayoutInformationModal.accountHolder"></FormattedMessage>
				<BoldParagraph>{props.bankAccountOwnerName}</BoldParagraph>
				<FormattedMessage id="completePayoutInformationModal.accountHolderIBAN"></FormattedMessage>
				<BoldParagraph>{props.bankAccountNumber}</BoldParagraph>
			</DetailContainer>
		</>
	);
};

const Paragraph = styled.p`
	font-size: 0.93em;
	margin-bottom: 1rem;
	hyphens: auto;
`;

const BoldParagraph = styled(Paragraph)`
	font-weight: bold;
`;
